import { format } from "date-fns";
import { ValidarMembresia } from "../utils/ValidarMembresia.js";
import ReCAPTCHA from "react-google-recaptcha";
import MyRecaptcha from "../components/pago/myRecaptcha.jsx";

const Pago = ({
  evento,
  info,
  setInfo,
  onChange,
  onClick,
  required,
  loading,
  me,
  membresia,
  cupon,
  apCupon,
  setApCupon,
  creditPaymentMethods,
  debitPaymentMethods,
  setRecaptcha,
  recaptchaError,
  requestError,
  isChecked,
  setIsChecked
}) => {
  const disabledInfoCard = false //evento.info.total > 0 ? false : true;
  return (
    <div className="container-fluid min-vh-100 py-4" style={{ backgroundColor: "#f5f5f5" }}>
      <div className="d-flex justify-content-center align-items-start px-1 px-md-0">
        <div className="row w-100" style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div className="col-md-7 col-12 position-relative placeholder-glow order-2 order-md-1">
            <div
              className={`justify-content-center align-items-center
              placeholder placeholder-lg ${loading ? " d-flex " : " d-none "}`}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 3,
              }}
            ></div>

            {/* Header con logo Decidir */}
            <div className="mb-4 bg-white p-4" style={{ borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <div className="d-flex align-items-center mb-3">
                <img src="/assets/img/decidir.png" alt="Decidir" style={{ height: "40px" }} />
              </div>
              <div className="d-flex align-items-center text-muted" style={{ fontSize: "14px" }}>
                <svg width="16" height="16" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                </svg>
                <div>
                  <strong>Pago 100% seguro</strong>
                  <div style={{ fontSize: "12px" }}>Tus datos están protegidos</div>
                </div>
              </div>
            </div>

            {/* Sección Métodos de Pago */}
            <div className="mb-4 bg-white p-4" style={{ borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <h3 className="fw-bold mb-3" style={{ fontSize: "16px" }}>
                1. Elegí tu método de pago
              </h3>
              <div className="mb-3">
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label
                      className={`d-block p-3 border ${info.credito ? 'border-primary border-2' : 'border-secondary'}`}
                      style={{ borderRadius: "8px", cursor: "pointer", position: "relative" }}
                    >
                      <input
                        className="position-absolute"
                        style={{ top: "16px", right: "16px" }}
                        type="radio"
                        value={"credito"}
                        name="tipo"
                        onChange={(e) => onChange(e)}
                        disabled={disabledInfoCard}
                        checked={info.credito}
                      />
                      <div className="d-flex align-items-center">
                        <svg width="32" height="32" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
                          <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
                        </svg>
                        <div>
                          <div className="fw-bold">Tarjeta de crédito</div>
                          <small className="text-muted">Visa, Mastercard, Amex</small>
                        </div>
                      </div>
                      {info.credito && (
                        <div className="position-absolute" style={{ top: "16px", right: "16px" }}>
                          <svg width="20" height="20" fill="#0d6efd" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                          </svg>
                        </div>
                      )}
                    </label>
                  </div>
                  <div className="col-12 col-md-6">
                    <label
                      className={`d-block p-3 border ${info.debito ? 'border-primary border-2' : 'border-secondary'}`}
                      style={{ borderRadius: "8px", cursor: "pointer", position: "relative" }}
                    >
                      <input
                        className="position-absolute"
                        style={{ top: "16px", right: "16px" }}
                        type="radio"
                        value={"debito"}
                        name="tipo"
                        onChange={(e) => onChange(e)}
                        disabled={disabledInfoCard}
                        checked={info.debito}
                      />
                      <div className="d-flex align-items-center">
                        <svg width="32" height="32" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/>
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                          <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
                        </svg>
                        <div>
                          <div className="fw-bold">Tarjeta de débito</div>
                          <small className="text-muted">Débito inmediato</small>
                        </div>
                      </div>
                      {info.debito && (
                        <div className="position-absolute" style={{ top: "16px", right: "16px" }}>
                          <svg width="20" height="20" fill="#0d6efd" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                          </svg>
                        </div>
                      )}
                    </label>
                  </div>
                </div>
                {required.debito_credito && (
                  <span className="text-danger fw-bold d-block mt-2" style={{ fontSize: "14px" }}>
                    Selecciona que tarjeta estás utilizando
                  </span>
                )}
              </div>

              <div className={`${info.credito ? "" : "d-none"}`}>
                <select
                  className="form-select py-2"
                  disabled={disabledInfoCard}
                  style={{ borderRadius: "8px", fontSize: "14px" }}
                  name="payment_method_id"
                  onChange={(e) => onChange(e)}
                >
                  <option selected>Selecciona un método de pago</option>
                  {creditPaymentMethods.map((paymentMethod) => {
                    return (
                      <option value={paymentMethod.value}>
                        {paymentMethod.label}
                      </option>
                    );
                  })}
                </select>
                {required.payment_method_id && (
                  <span className="text-danger fw-bold d-block mt-2" style={{ fontSize: "14px" }}>
                    Selecciona un método de pago válido
                  </span>
                )}
              </div>

              <div className={`${info.debito ? "" : "d-none"}`}>
                <select
                  className="form-select py-2"
                  disabled={disabledInfoCard}
                  style={{ borderRadius: "8px", fontSize: "14px" }}
                  name="payment_method_id"
                  onChange={(e) => onChange(e)}
                >
                  <option selected>Selecciona un método de pago</option>
                  {debitPaymentMethods.map((paymentMethod) => {
                    return (
                      <option value={paymentMethod.value}>
                        {paymentMethod.label}
                      </option>
                    );
                  })}
                </select>
                {required.payment_method_id && (
                  <span className="text-danger fw-bold d-block mt-2" style={{ fontSize: "14px" }}>
                    Selecciona un método de pago válido
                  </span>
                )}
              </div>
            </div>

            {/* Sección Información de la Tarjeta */}
            <div className="mb-4 bg-white p-4" style={{ borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <h3 className="fw-bold mb-3" style={{ fontSize: "16px" }}>
                2. Información de la tarjeta
              </h3>

              <div className="mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Número de tarjeta
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="form-control py-2"
                    style={{ borderRadius: "8px", fontSize: "14px", paddingRight: "100px" }}
                    placeholder="4242 4242 4242 4242"
                    value={info.numero}
                    name="numero"
                    onChange={(e) => onChange(e)}
                    required
                    disabled={disabledInfoCard}
                  />
                  <div style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", gap: "4px" }}>
                    <img src="/assets/img/visa.svg" alt="Visa" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
                    <img src="/assets/img/mastercard.svg" alt="Mastercard" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
                    <img src="/assets/img/amex.svg" alt="Amex" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
                  </div>
                </div>
                {required.numero && (
                  <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                    El número de la tarjeta es obligatorio
                  </span>
                )}
              </div>

              <div className="row g-3 mb-3">
                <div className="col-12 col-md-4">
                  <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                    Vencimiento
                  </label>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control py-2"
                      style={{ borderRadius: "8px", fontSize: "14px" }}
                      placeholder="MM / AA"
                      value={info.mes && info.año ? `${info.mes} / ${info.año}` : ''}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        if (val.length <= 2) {
                          onChange({ target: { name: 'mes', value: val } });
                        } else {
                          onChange({ target: { name: 'mes', value: val.substring(0, 2) } });
                          onChange({ target: { name: 'año', value: val.substring(2, 4) } });
                        }
                      }}
                      disabled={disabledInfoCard}
                    />
                  </div>
                  {(required.mes || required.año) && (
                    <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                      Fecha requerida
                    </span>
                  )}
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                    Código de seguridad
                    <svg width="14" height="14" className="ms-1" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                    </svg>
                  </label>
                  <input
                    className="form-control py-2"
                    style={{ borderRadius: "8px", fontSize: "14px" }}
                    type="password"
                    placeholder="CVV"
                    maxLength="7"
                    name="codigo"
                    onChange={(e) => onChange(e)}
                    onFocus={(e) => setInfo({ ...info, focusCVV: true })}
                    onBlur={(e) => setInfo({ ...info, focusCVV: false })}
                    disabled={disabledInfoCard}
                  />
                  {required.codigo && (
                    <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                      CVV requerido
                    </span>
                  )}
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                    DNI del titular
                  </label>
                  <input
                    className="form-control py-2"
                    style={{ borderRadius: "8px", fontSize: "14px" }}
                    type="text"
                    placeholder="12345678"
                    maxLength="9"
                    name="dni"
                    onChange={(e) => onChange(e)}
                    disabled={disabledInfoCard}
                  />
                  {required.dni && (
                    <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                      DNI requerido
                    </span>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Nombre y apellido del titular
                </label>
                <input
                  type="text"
                  className="form-control py-2"
                  name="titular"
                  value={info.titular}
                  onChange={(e) => onChange(e)}
                  placeholder="Rodrigo Brunelli"
                  style={{ borderRadius: "8px", fontSize: "14px" }}
                  disabled={disabledInfoCard}
                />
                {required.titular && (
                  <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                    El nombre y apellido del titular es obligatorio
                  </span>
                )}
              </div>
            </div>

            {/* Sección Datos Personales */}
            <div className="mb-4 bg-white p-4" style={{ borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <h3 className="fw-bold mb-3" style={{ fontSize: "16px" }}>
                3. Tus datos de contacto
              </h3>
              <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
                Lo vamos a utilizar para enviarte tu entrada o contactarte en caso de que sea necesario.
              </p>

              <div className="mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Email
                </label>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}>
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"/>
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control py-2"
                    style={{ borderRadius: "8px", fontSize: "14px", paddingLeft: "40px" }}
                    name="email"
                    placeholder="rodrigo@antesala.com"
                    defaultValue={info.email}
                    onChange={(e) => onChange(e)}
                  />
                </div>
                {required.email && (
                  <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                    El mail es necesario para recibir tus entradas!
                  </span>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Teléfono
                </label>
                <div className="d-flex gap-2">
                  <select className="form-select" style={{ maxWidth: "100px", borderRadius: "8px", fontSize: "14px" }}>
                    <option value="+54">+54</option>
                  </select>
                  <input
                    type="text"
                    className="form-control py-2"
                    style={{ borderRadius: "8px", fontSize: "14px", flex: 1 }}
                    name="telefono"
                    placeholder="11 4935 3420"
                    defaultValue={info.telefono}
                    onChange={(e) => onChange(e)}
                  />
                </div>
                {required.telefono && (
                  <span className="text-danger fw-bold d-block mt-1" style={{ fontSize: "14px" }}>
                    El teléfono es necesario para poder contactarte!
                  </span>
                )}
              </div>

              {requestError.status && (
                <div className="alert alert-danger mb-0" style={{ fontSize: "14px", borderRadius: "8px" }}>
                  {requestError.msg}
                </div>
              )}

              <div className="mt-4 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", borderLeft: "4px solid #0d6efd" }}>
                <div className="d-flex align-items-start">
                  <svg width="20" height="20" className="me-2 mt-1 flex-shrink-0" fill="#0d6efd" viewBox="0 0 16 16">
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                  </svg>
                  <div style={{ fontSize: "13px" }}>
                    <strong className="d-block mb-1">Tu pago está protegido</strong>
                    <span className="text-muted">Usamos encriptación SSL y cumplimos con los más altos estándares de seguridad.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-5 col-12 order-1 order-md-2 mb-4 mb-md-0">
            <div className="bg-white p-4" style={{ borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", position: "sticky", top: "20px" }}>
              <h3 className="fw-bold mb-3" style={{ fontSize: "16px" }}>
                Resumen de tu compra
              </h3>

              <div
                className="overflow-hidden mb-3"
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "56.25%",
                  borderRadius: "8px"
                }}
              >
                <img
                  src={`https://antesala.com.ar/assets/img/eventos/${evento.evento.imagen}`}
                  alt=""
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            <div>
              <h4 className="fw-bold mb-2" style={{ fontSize: "15px" }}>{evento.evento.nombre}</h4>
              <div className="d-flex align-items-center text-muted mb-3" style={{ fontSize: "14px" }}>
                <svg width="16" height="16" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
                <span>{evento.select.fecha}</span>
              </div>
              <div className="d-flex align-items-center text-muted mb-3" style={{ fontSize: "14px" }}>
                <svg width="16" height="16" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                </svg>
                <span>{evento.select.hora}</span>
              </div>

              <div className="mb-3">
                <h5 className="fw-bold mb-2" style={{ fontSize: "14px" }}>Entradas</h5>
                {evento.evento.entradas.map((entrada, index) => {

                  let descuento = null;
                  if (entrada?.membresia) {
                    descuento = entrada.pricexquantity;
                  }

                  if (entrada.quantity > 0) {
                    return (
                      <div className="mb-2 pb-2" key={index} style={{ borderBottom: "1px solid #e9ecef" }}>
                        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "14px" }}>
                          <span>{entrada.nombre}</span>
                          <span className="text-muted">x {entrada.quantity}</span>
                        </div>
                        <div className={`d-flex justify-content-between ${entrada?.membresia ? 'text-decoration-line-through text-muted' : ''}`} style={{ fontSize: "14px" }}>
                          <span>Precio</span>
                          <span>ARS {parseFloat(entrada.precio).toLocaleString("es-AR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}</span>
                        </div>
                        {entrada?.membresia && (
                          <div className="d-flex justify-content-between" style={{ fontSize: "14px" }}>
                            <span>Precio con membresía</span>
                            <span className="fw-bold">ARS {parseFloat(descuento).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}</span>
                          </div>
                        )}
                      </div>
                    );
                  }
                })}
              </div>

              <div className="mb-3 pb-3" style={{ borderBottom: "1px solid #e9ecef" }}>
                <div className="d-flex justify-content-between mb-2" style={{ fontSize: "14px" }}>
                  <span>Precio</span>
                  <span>ARS {parseFloat(evento.info.subTotal).toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</span>
                </div>
                <div className="d-flex justify-content-between" style={{ fontSize: "14px" }}>
                  <span>Servicio ({evento.evento.comisiones.tasa}%)</span>
                  <span>ARS {parseFloat(evento.info.serv).toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</span>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center" style={{ fontSize: "18px" }}>
                  <span className={evento.info?.totalCupon ? "text-decoration-line-through text-muted" : "fw-bold"}>
                    Total
                  </span>
                  <span className={evento.info?.totalCupon ? "text-decoration-line-through text-muted" : "fw-bold"}>
                    ARS {parseFloat(evento.info.total).toLocaleString("es-AR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                {evento.info?.totalCupon && (
                  <div className="d-flex justify-content-between align-items-center mt-2" style={{ fontSize: "20px", color: "#28a745" }}>
                    <span className="fw-bold">Total - ({cupon?.data?.descuento}%)</span>
                    <span className="fw-bold">ARS {parseFloat(evento.info.totalCupon).toLocaleString("es-AR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) ?? 0.0}</span>
                  </div>
                )}
              </div>

              {evento?.evento.cupones.length > 0 && (
                <div className="mb-3">
                  <label className="fw-medium mb-2 d-block" style={{ fontSize: "14px", cursor: "pointer" }} onClick={() => setApCupon(!apCupon)}>
                    <span className="text-primary">¿Podés pagar en cuotas</span>
                    <div className="text-muted" style={{ fontSize: "12px" }}>Con tarjetas de crédito seleccionadas.</div>
                    <button className="d-none" onClick={() => setApCupon(!apCupon)}></button>
                  </label>
                  {apCupon && (
                    <div>
                      <input
                        type="text"
                        className="form-control py-2"
                        style={{ borderRadius: "8px", fontSize: "14px" }}
                        name="cupon"
                        placeholder="Ingresá tu código de cupón"
                        onChange={(e) => onChange(e)}
                        disabled={disabledInfoCard || loading}
                      />
                      {cupon.msg && (
                        <span className="text-muted d-block mt-1" style={{ fontSize: "12px" }}>
                          {cupon.msg}
                        </span>
                      )}
                      <a href="#" className="text-primary d-block mt-2" style={{ fontSize: "13px", textDecoration: "none" }}>Ver promociones</a>
                    </div>
                  )}
                </div>
              )}

              {me?.membresias?.length > 0 && (
                <div className="mb-3">
                  <h5 className="fw-bold mb-2" style={{ fontSize: "14px" }}>Membresía</h5>
                  {me.membresias.map((mem) => {
                    if (ValidarMembresia(mem, evento?.evento.entradas)) {
                      return (
                        <label
                          key={mem.id}
                          className={`d-block p-3 mb-2 border ${mem.id == membresia?.id ? 'border-primary border-2 bg-light' : 'border-secondary'}`}
                          style={{ borderRadius: "8px", cursor: "pointer" }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <div className="fw-bold" style={{ fontSize: "14px" }}>{mem.name}</div>
                              <small className="text-muted">
                                {`Puedes abonar ${mem.limit} ${mem.limit > 1 ? "entradas" : "entrada"}`}
                              </small>
                            </div>
                            {loading && mem.id == membresia?.id && (
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            )}
                          </div>
                          <button
                            className="d-none"
                            name={mem.id == membresia?.id ? "quitar-membresia" : "abonar-con-membresia"}
                            onClick={(e) => onClick(e, mem)}
                          ></button>
                        </label>
                      );
                    }
                    return null;
                  })}
                </div>
              )}

              <div className="d-flex align-items-center justify-content-center mb-2">
                <svg width="16" height="16" className="me-1" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                  <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                </svg>
                <small className="text-muted" style={{ fontSize: "12px" }}>Sin cargos ocultos</small>
              </div>

              {loading ? (
                <button
                  className="btn w-100 py-3 mb-2 text-white d-flex align-items-center justify-content-center"
                  style={{ borderRadius: "8px", backgroundColor: "#0d6efd", fontSize: "16px", fontWeight: "600" }}
                  disabled
                >
                  <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                  </svg>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Procesando pago...
                </button>
              ) : (
                <label
                  className="btn w-100 py-3 mb-2 text-white d-flex align-items-center justify-content-center"
                  style={{ borderRadius: "8px", backgroundColor: "#0d6efd", fontSize: "16px", fontWeight: "600", cursor: "pointer" }}
                >
                  <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                  </svg>
                  Pagar ARS {parseFloat(evento.info?.totalCupon || evento.info.total).toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  <button
                    className="d-none"
                    name="pagar"
                    onClick={(e) => onClick(e)}
                  ></button>
                </label>
              )}

              <div className="text-center mb-3">
                <span className="d-block mb-2" style={{ fontSize: "12px" }}>o</span>
                {loading ? (
                  <button
                    className="btn btn-outline-primary w-100 py-2 d-flex align-items-center justify-content-center"
                    style={{ borderRadius: "8px", fontSize: "14px" }}
                    disabled
                  >
                    <div className="spinner-border spinner-border-sm me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Procesando...
                  </button>
                ) : (
                  <label
                    className="btn btn-outline-primary w-100 py-2 d-flex align-items-center justify-content-center"
                    style={{ borderRadius: "8px", fontSize: "14px", cursor: "pointer" }}
                  >
                    <img
                      src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 40'%3E%3Ctext x='10' y='25' font-family='Arial' font-size='16' font-weight='bold' fill='%2300AAFF'%3EMercado Pago%3C/text%3E%3C/svg%3E"
                      alt="Mercado Pago"
                      style={{ height: "20px", marginRight: "8px" }}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                    Pagar con Mercado Pago
                    <button
                      className="d-none"
                      name="pagar_mercado_pago"
                      onClick={(e) => onClick(e)}
                    ></button>
                  </label>
                )}
              </div>

              <div className="mb-3">
                <ReCAPTCHA
                  sitekey="6LeAUIQsAAAAACd1XmNbNaF5yOmW3_aEqZsI388x"
                  onChange={(token) => setRecaptcha(token)}
                />
              </div>

              <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                <span style={{ fontSize: "12px", color: "#6c757d" }}>Aceptamos</span>
                <img src="/assets/img/visa.svg" alt="Visa" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
                <img src="/assets/img/mastercard.svg" alt="Mastercard" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
                <img src="/assets/img/amex.svg" alt="Amex" style={{ height: "20px" }} onError={(e) => e.target.style.display = 'none'} />
              </div>

              <div className="text-center mb-2">
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  ¿Necesitás ayuda? <a href="#" className="text-primary" style={{ textDecoration: "none" }}>Contactanos</a>
                </small>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white py-4" style={{ borderTop: "1px solid #e9ecef" }}>
        <div className="row align-items-center" style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <p className="m-0 text-muted" style={{ fontSize: "12px" }}>
              {`© Copyright - 2022 - ${format(new Date(), "Y").toString()} | Antesala.`}
            </p>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-center justify-content-md-end align-items-center gap-3">
              <span className="text-muted" style={{ fontSize: "11px" }}>Powered by</span>
              <img src="/assets/img/decidir.png" alt="Decidir" style={{ height: "24px" }} onError={(e) => e.target.style.display = 'none'} />
              <div className="d-flex gap-2">
                <div style={{ padding: "4px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "10px", fontWeight: "600" }}>
                  PCI DSS
                </div>
                <div style={{ padding: "4px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "10px", fontWeight: "600" }}>
                  SSL
                </div>
                <div style={{ padding: "4px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "10px", fontWeight: "600" }}>
                  Verified
                </div>
                <div style={{ padding: "4px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "10px", fontWeight: "600" }}>
                  SecureCode
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pago;
